const actions = {
  //- Sets the selected user
  setSelectedUser ({ commit }, user) {
    console.log('Userstore - setSelectedUser')

    //- Mutate store
    commit('SET_SEL_USER', user)
  }
  
}

export default actions
